import React, { useState } from "react";
//import { supabaseClient2 } from '../SupabaseClient';
function ContactForm({ isDarkMode }) {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");
  
  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };
//////////
const handleSubmit = async (e) => {
e.preventDefault();
try {
const response = await fetch(
`${process.env.REACT_APP_ENQUIRY_SUPABASE_URL}/functions/v1/send-enquiry-mailtrap`,
{
  
method: 'POST',
headers: {
  
'Content-Type': 'application/json',
//"Authorization": `Bearer REACT_APP_ENQUIRY_SUPABASE_ANON_KEY`,
 
},
body: JSON.stringify(formData),
}
);
//console.log("Full Function URL:", `${process.env.REACT_APP_ENQUIRY_SUPABASE_URL}/functions/v1/send-enquiry-mailtrap`);

const result = await response.json();
if (result.message) {
  setSubmitted(true);
  setFormData({ name: "", email: "", phone: "", message: "" });
  alert('Notification Sent Successfully');
} else {
  alert('Failed to send notification');
}

} catch (error) {
console.error(error);
alert('Error: ' + error.message);
}
};


/////////////
  
  
  return (
//style={{ backgroundColor:'eef2f7'}}
     <div
      className="container-fluid shadow mb-4"
      style={{ 
        backgroundColor: isDarkMode ? '' : '#eef2f7',
        color: isDarkMode ? '#f8f9fa' : '#212529',
      }}
    >
      <h1 className="text-center heading-title fw-bold ">Make an Enquiry</h1>
      <p className="text-muted mb-4 text-center"> Have a question or need assistance? Our Enquiry Page is your direct line to our support team. 
        Whether you’re looking for information about AVVs, Model Reports, payments, or documentation,<br/> we’re here to help.
     Simply fill out the form with your details and message, and one of our specialists will get back to you promptly.</p>
      <div className="d-flex justify-content-center">
      <div className="row g-0 align-items-center mb-4">
        <div className="col-md-4 col-sm-12 d-none d-lg-block">

  <img
    src="/image/Enquiry.svg"
    alt="Enquiry illustration"
    style={{
      maxWidth: '100%',
      height: 'auto',
      width: '100%' 
    }}
  />

</div>
<div className="col-12 col-lg-8 px-4">
    
    <div className="container mt-5" style={{ maxWidth: "600px" }}>
      

      <form onSubmit={handleSubmit}>
        {/* Name */}
        <div className="mb-3">
          <label htmlFor="name" className="form-label">
            Name:
          </label>
          <input
            type="text"
            className="form-control"
            name="name"
            id="name"
            value={formData.name}
            onChange={handleChange}
            required
            placeholder="Please Enter Your Name"
          />
        </div>

        {/* Email */}
        <div className="mb-3">
          <label htmlFor="email" className="form-label">
            Email:
          </label>
          <input
            type="email"
            className="form-control"
            name="email"
            id="email"
            value={formData.email}
            onChange={handleChange}
            required
             placeholder="example@mail.com"
          />
        </div>

        {/* Phone */}
        <div className="mb-3">
          <label htmlFor="phone" className="form-label">
            Phone:
          </label>
          <input
            type="tel"
            className="form-control"
            name="phone"
            id="phone"
             
            value={formData.phone}
            onChange={handleChange}
            required
    maxLength="10"
    pattern="[0-9]{10}"
    title="Please enter exactly 10 digits"
          />
        </div>

        {/* Message */}
        <div className="mb-3">
          <label htmlFor="message" className="form-label">
            Message:
          </label>
          <textarea
            className="form-control"
            name="message"
            id="message"
            rows="4"
            value={formData.message}
            onChange={handleChange}
            required
          />
        </div>

        {/* Submit */}
        <div className="text-center">
          <button type="submit" className="btn btn-success px-4">
            Submit
          </button>
        </div>

        {/* Alerts */}
        {submitted && (
          <div className="alert alert-success mt-3 text-center">
            ✅ Message sent! We'll get back to you shortly.
          </div>
        )}
        {error && (
          <div className="alert alert-danger mt-3 text-center">{error}</div>
        )}
      </form>
    </div>
    </div>
    </div>
    </div>
    </div>
  );
}

export default ContactForm;
